import { Component } from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Tags from '../tags/tags'
import Form from '../forms/form'
import FormGroup from '../forms/form_group'
import Label from '../forms/label'
import Input from '../forms/input'
import Button from '../Button'
import SpinnerButton from '../forms/spinner_button'
import HiddenInput from '../forms/hidden_input'
import AuthenticityToken from '../forms/authenticity_token'
import SVGIcon from '../SVGIcon.tsx'

export default class TimelineTags extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showTagForm: false,
      inputValue: '',
      submitting: false,
    }
  }

  toggleFormVisibility = () => {
    this.setState({
      showTagForm: !this.state.showTagForm,
    })
  }

  handleFieldChange = ({ name, value }) => {
    this.setState({
      inputValue: value,
    })
  }

  handleClickDismiss = e => {
    e.preventDefault()
    this.toggleFormVisibility()
  }

  handleSubmit = e => {
    // Note: Do not prevent event default here
    this.setState({
      submitting: true,
    })
    return true
  }

  getTagsContent() {
    const { tags, canTag } = this.props
    return <Tags tags={tags} onClickAddTag={this.toggleFormVisibility} showAddTag={canTag} />
  }

  getTagFormContent() {
    const { canTag, createTagsPath, timelineId } = this.props
    const { showTagForm, inputValue, submitting } = this.state
    if (showTagForm && canTag) {
      return (
        <CSSTransition classNames="slide-in-out-300px" timeout={600}>
          <div className="timeline-tags__form-container">
            <div className="p-t">
              <Button className="button-reset dismiss-button right" onClick={this.handleClickDismiss}>
                <SVGIcon pointerEvents="none" alt="Close" xlinkHref="#streamline-delete-1" />
              </Button>
              <Form className="form form--limited-inputs" action={createTagsPath} onSubmit={this.handleSubmit}>
                <p>Tags will help people find this timeline when browsing the site.</p>
                <HiddenInput name="taggable_type" value="Timeline" />
                <HiddenInput name="taggable_id" value={timelineId} />
                <AuthenticityToken />
                <FormGroup className="form-group">
                  <Label htmlFor="tag-input" className="label">
                    Timeline tags
                  </Label>
                  <Input
                    id="tag-input"
                    name="tag"
                    value={inputValue}
                    onChange={this.handleFieldChange}
                    placeholder="Comma separate tags e.g. history, civil war, world etc."
                  />
                </FormGroup>
                <FormGroup className="form-group form-group-buttons form-group-buttons--left">
                  <div className="form-group-buttons__container">
                    <SpinnerButton className="btn btn--primary" disabled={submitting} name="submit" type="submit">
                      Add these timeline tags +
                    </SpinnerButton>
                  </div>
                </FormGroup>
              </Form>
            </div>
          </div>
        </CSSTransition>
      )
    }
    return null
  }

  render() {
    const { tags, canTag } = this.props
    const haveTags = tags.length > 0
    if (haveTags || canTag) {
      const tagsContent = this.getTagsContent()
      const tagForm = this.getTagFormContent()
      return (
        <div className="timeline-tags">
          {tagsContent}
          <TransitionGroup>{tagForm}</TransitionGroup>
        </div>
      )
    }
    return null
  }
}
TimelineTags.propTypes = {
  tags: PropTypes.array.isRequired,
  canTag: PropTypes.bool.isRequired,
  createTagsPath: PropTypes.string.isRequired,
  timelineId: PropTypes.number.isRequired,
}
TimelineTags.defaultProps = {
  tags: [],
  canTag: false,
}
